"use client";

import { useEffect } from "react";
import { startBoeklinkMeting, stap } from "@/lib/funnel/stap";

/**
 * Funnelmeting (24-10-2026): de eerste boekstap, "dealpagina_bekeken". Rendert
 * niets en verandert niets aan de pagina; stuurt één beacon per dealweergave
 * via src/lib/funnel/stap.js (geen cookie, geen storage, geen PII).
 *
 * Geeft ook de reis en de herkomst mee naar het boeken: bij een klik op een
 * link naar /booking/ komen `fr`, `fb` en (bij gclid) `fa=1` op die link.
 */
export default function FunnelDealpagina({ dealId }) {
  useEffect(() => {
    if (dealId == null) return;
    stap("dealpagina_bekeken", { deal: dealId });
  }, [dealId]);

  useEffect(() => startBoeklinkMeting(), []);

  return null;
}
